import React from "react";

/**
 * Fair Rideshare logo — geometric "F" + steering-wheel-inspired mark.
 * Variants: 'dark' (black on light) | 'light' (white on dark)
 */
export default function Logo({ variant = "dark", showWordmark = true, className = "" }) {
  const fg = variant === "light" ? "#ffffff" : "#0a0a0a";
  const accent = variant === "light" ? "#f59e0b" : "#d97706";
  return (
    <div className={`inline-flex items-center gap-2.5 ${className}`} data-testid="brand-logo">
      <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden>
        <rect x="0" y="0" width="32" height="32" rx="7" fill={fg} />
        {/* Road / motion lines */}
        <rect x="6" y="14" width="14" height="2" rx="1" fill={accent} />
        <rect x="6" y="19" width="9" height="2" rx="1" fill={accent} opacity="0.7" />
        {/* Stylised F */}
        <path d="M22 7 L22 25 M22 7 L27 7 M22 14 L26 14" stroke={variant === "light" ? "#0a0a0a" : "#ffffff"} strokeWidth="2.2" strokeLinecap="round" />
      </svg>
      {showWordmark && (
        <div className="leading-none">
          <div className="font-heading font-extrabold text-base tracking-tight" style={{ color: fg }}>Fair Rideshare</div>
          <div className="text-[9px] uppercase tracking-[0.22em] mt-0.5" style={{ color: variant === "light" ? "#a3a3a3" : "#737373" }}>Philadelphia · LLC</div>
        </div>
      )}
    </div>
  );
}
